module.exports = __webpack_public_path__ + "static/media/advent-background-bow.afb0ac25.jpg";